import styled from 'styled-components'

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => props.theme.whiteLabel.spacing.sp24};
`
